<template>
  <div class="annuity-refund">
    <div class="container-fluid px-5">
      <div class="content-wrapper">
        <div class="page-header d-flex align-items-center mb-5">
          <button class="btn-back size-arrow mr-3" @click="$router.go(-1)">
            <img :src="arrowBack" alt="Voltar" />
          </button>
          <h1 class="page-title mb-0">Reembolso de Anuidade</h1>
        </div>

        <div class="row">
          <div class="col-card">
            <AnnuityRefundForm />
          </div>

          <div class="col-card">
            <div class="right-card-container">
              <AnnuityRefundRules />
              <AnnuityRefundSchedule />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnnuityRefundForm from "../components/AnnuityRefundForm.vue";
import AnnuityRefundRules from "../components/AnnuityRefundRules.vue";
import AnnuityRefundSchedule from "../components/AnnuityRefundSchedule.vue";

import arrowBack from "@/assets/images/arrow_back.svg";

export default {
  name: "AnnuityRefund",
  components: {
    AnnuityRefundForm,
    AnnuityRefundRules,
    AnnuityRefundSchedule,
  },
  data() {
    return {
      arrowBack,
    };
  },
};
</script>

<style scoped>
* {
  font-family: "Trebuchet MS", sans-serif !important;
}

.content-wrapper {
  max-width: 1016px;
  margin: 0 auto;
}

.row {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  align-items: flex-start; 
}

.col-card {
  width: 492px;
  display: flex;
  flex-direction: column;
}


.right-card-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
}

.annuity-refund {
  padding: 40px 16px;
  background-color: var(--backgrount-2);
  min-height: calc(100vh - 64px);
  margin: 0 auto;
}

.container-fluid {
  max-width: 1440px;
}

.page-title {
  color: var(--grey-4);
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 33.6px;
}

@media (max-width: 1112px) {
  .page-header {
    width: 492px;
    margin-left: auto;
    margin-right: auto;
  }
}

.btn-back {
  background: none;
  border: none;
  color: var(--green-3);
  font-size: 1.4rem;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
}

.btn-back:hover {
  opacity: 0.7;
}

.size-arrow i {
  font-size: 24px;
}
</style>